import React from "react";
import ContactForm from "./ContactForm";

export default function Contact() {
  return (
    <div id="contact" className="min-h-screen relative py-16">
      <div className="w-11/12 sm:w-10/12 md:w-8/12 flex flex-col mx-auto">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Image — hidden on mobile, shown md+ */}
          <div className="hidden md:block md:w-6/12">
            <img
              className="w-full h-full object-cover max-h-[600px]"
              src={`${process.env.PUBLIC_URL}/images/contact.jpg`}
              alt=""
            />
          </div>
          {/* Form */}
          <div className="w-full md:w-6/12">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}